import { ProdAttrUtils } from "./../utils/productAttributeUtils";
import { useTranslation } from "react-i18next";
import {
  PA_GROUP,
  PA_NAME,
} from "../types/product-attribute/product-attribute";
import { toAgeString } from "../utils/common";
export const useProdaName = () => {
  const { t } = useTranslation();

  const prodaName = (productAttribute?: ProdaFE | null) => {
    return prodaNameUtils(productAttribute)
      .map((x) => {
        // Check if x start with (age
        //  Get age from space after  age and before )
        if (x.startsWith("(age")) {
          const age = x.split(" ")[1];
          // remove ) from age
          const ageTo = age.split(")")[0];
          const ageStr = toAgeString(ageTo);
          if (ageStr === "<1") {
            return `(${t("Child <1 age")})`;
          }
          return t("(age )", { age: ageStr });
        }
        return t(x);
      })
      .join(" ");
  };

  return {
    prodaName,
    showAgeLs: (state: BookingState) => {
      return ProdAttrUtils.parseAgeLs(state)
        .map((x) => {
          if (x.quantity) {
            return (
              prodaName({
                name: x.age as ProdAttrName,
              }) +
              " x " +
              x.quantity
            );
          }
          return null;
        })
        .filter(Boolean)
        .join(", ");
    },
  };
};

export const prodaNameUtils = (productAttribute?: ProdaFE | null): string[] => {
  if (!productAttribute) return [];
  const name = productAttribute.name;
  const value = productAttribute.value;
  if (name.startsWith("CHILD")) {
    try {
      const v = value || name;
      if (v) {
        const { ageFrom, ageTo } = ProdAttrUtils.CHILD.parseAge(v);
        if (ageFrom >= 0 && ageTo >= 0) {
          return ["Child", `(age ${ageFrom} - ${ageTo})`];
        } else if (ageFrom >= 0) {
          return ["Child", `(age ${ageFrom})`];
        }
      }
    } catch (e) {}
    return ["Child"];
  }
  if (name === ("TOUR_ROOM_ADULT_MAX_FEE_TOTAL" as any)) {
    return ["Additional adult"];
  }
  if (name === ("TOUR_ROOM_CHILD_MAX_FEE_TOTAL" as any)) {
    return ["Additional child"];
  }
  if (name === "ADULT") {
    return ["Adult"];
  }
  if (name === "PERSON") {
    return ["Person"];
  }
  if (name === "Q_SIM") {
    return ["Sim"];
  }
  if (name === "SIM") {
    return ["Esim"];
  }
  if (name === "ROOM") {
    return ["Room"];
  }
  if (PA_GROUP.ADDITIONAL_OPTIONS.includes(name)) {
    return [value ?? name ?? ""];
  }
  // if (name === "PRIORITY_CALENDAR") {
  //   return t("Priority");
  // }
  if (name === "LUGGAGE") {
    return ["Luggage"];
  }
  if (name === "Q_VEHICLE") {
    return ["Vehicle"];
  }
  if (name === "AIRPORT") {
    return ["Pickup location"];
  }
  if (PA_NAME.CALENDAR.includes(name as ProdAttrNameCalendar)) {
    return value ? [value] : ["Select date"];
  }
  return [];
};
